import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Tbody from "./Tbody";
import Thead from "./Thead";

export default function Table() {
  const state = useSelector((state) => state.flights);
  const [limitText, setLimitText] = useState();
  useEffect(() => {
    if (state.length >= 3) {
      setLimitText(true);
    } else {
      setLimitText(false);
    }
  }, [state]);
  return (
    <>
      <div className="table-container">
        <table className="booking-table">
          <Thead />
          <Tbody />
        </table>
        <h4 className={`limitText ${limitText && "show"}`}>
          Exceeded the limit. Please upgrade to pro version to book more😄
        </h4>
      </div>
    </>
  );
}
